import React from 'react';
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import {
  FilterToken,
  GridFiltersButton,
  GridPagination,
  GridSearch,
  GroupByButton,
} from '../../components/data-grid';
import { GROUP_BY, POOL_STATUSES } from './orders-pool.utils';

const GROUP_BY_OPTIONS = [
  { value: GROUP_BY.RECIPIENT_ONLY, label: 'Réceptionnaire' },
  { value: GROUP_BY.RECIPIENT, label: 'Réceptionnaire · date' },
  { value: GROUP_BY.ENTRY_DATE, label: "Date d'entrée" },
  { value: GROUP_BY.NONE, label: 'Aucun' },
];

// Sans statut choisi, le puits n'affiche que les lignes disponibles
const DEFAULT_STATUSES = ['PLANNED'];

/**
 * Barre d'outils du puits : recherche, filtres (jetons), regroupement,
 * pagination
 */
export default function GridToolbar({
  query,
  onQueryChange,
  clientName,
  onClientNameChange,
  clientNames,
  createdDate,
  onCreatedDateChange,
  statuses,
  onStatusesChange,
  // Onglet « Supprimés » : pas de filtre de statut
  showStatusFilter = true,
  groupBy,
  onGroupByChange,
  paginationInfo,
  onOffsetChange,
}) {
  const isDefaultStatuses =
    !showStatusFilter ||
    statuses.length === 0 ||
    (statuses.length === 1 && statuses[0] === DEFAULT_STATUSES[0]);
  const activeStatuses = statuses.length > 0 ? statuses : DEFAULT_STATUSES;
  const activeFiltersCount =
    (clientName ? 1 : 0) + (createdDate ? 1 : 0) + (isDefaultStatuses ? 0 : 1);

  const toggleStatus = (status, checked) => {
    const next = checked
      ? [...activeStatuses, status]
      : activeStatuses.filter((value) => value !== status);
    onStatusesChange(next.length > 0 ? next : DEFAULT_STATUSES);
  };

  return (
    <div className="agv-dg-toolbar">
      <div className="agv-dg-toolbar__filters">
        <GridSearch
          value={query}
          onChange={onQueryChange}
          placeholder="Rechercher un BL, un réceptionnaire, une adresse…"
        />

        <GridFiltersButton activeCount={activeFiltersCount}>
          {() => (
            <div className="agv-dg-popover">
              <label className="agv-dg-popover__field">
                <span className="agv-dg-popover__label">Réceptionnaire</span>
                <select
                  value={clientName}
                  onChange={(e) => onClientNameChange(e.target.value)}
                >
                  <option value="">Tous les réceptionnaires</option>
                  {clientNames.map((name) => (
                    <option key={name} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
              </label>
              {showStatusFilter && (
                <div className="agv-dg-popover__field">
                  <span className="agv-dg-popover__label">Statut</span>
                  {Object.entries(POOL_STATUSES).map(
                    ([status, { label, color }]) => (
                      <label key={status} className="op-status-option">
                        <input
                          type="checkbox"
                          checked={activeStatuses.includes(status)}
                          onChange={(e) =>
                            toggleStatus(status, e.target.checked)
                          }
                        />
                        <span
                          className="agv-dg-dot"
                          style={{ backgroundColor: color }}
                        />
                        {label}
                      </label>
                    )
                  )}
                </div>
              )}
              <div className="agv-dg-popover__field">
                <span className="agv-dg-popover__label">
                  Date d&apos;entrée dans le puits
                </span>
                <ReactDatePicker
                  selected={createdDate ? new Date(createdDate) : null}
                  onChange={(date) =>
                    onCreatedDateChange(
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                  }
                  locale="fr"
                  inline
                />
              </div>
            </div>
          )}
        </GridFiltersButton>

        {activeFiltersCount > 0 && (
          <span className="agv-dg-toolbar__separator" />
        )}
        {clientName && (
          <FilterToken
            label="Réceptionnaire"
            value={clientName}
            onRemove={() => onClientNameChange('')}
          />
        )}
        {!isDefaultStatuses && (
          <FilterToken
            label="Statut"
            value={activeStatuses
              .map((status) => POOL_STATUSES[status]?.label || status)
              .join(', ')}
            onRemove={() => onStatusesChange(DEFAULT_STATUSES)}
          />
        )}
        {createdDate && (
          <FilterToken
            label="Entrée"
            value={moment(createdDate).format('D MMM YYYY')}
            onRemove={() => onCreatedDateChange('')}
          />
        )}
        {activeFiltersCount > 0 && (
          <button
            type="button"
            className="agv-dg-link"
            onClick={() => {
              onClientNameChange('');
              onCreatedDateChange('');
              if (showStatusFilter) onStatusesChange(DEFAULT_STATUSES);
            }}
          >
            Effacer
          </button>
        )}
      </div>

      <div className="agv-dg-toolbar__controls">
        <GroupByButton
          options={GROUP_BY_OPTIONS}
          value={groupBy}
          onChange={onGroupByChange}
        />
        <span className="agv-dg-toolbar__separator" />
        <GridPagination
          paginationInfo={paginationInfo}
          onOffsetChange={onOffsetChange}
        />
      </div>
    </div>
  );
}
